import { useEffect, useState } from "react";

export default function StickyNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-40 transition-all duration-300 overflow-hidden ${
        scrolled ? "border-b border-cream-200/30" : ""
      }`}
    >
      {/* Background image - full width with desktop zoom */}
      <div className="w-full flex justify-center h-[70px] md:h-[96px] overflow-hidden">
        <img
          src="https://storage.readdy-site.link/project_files/d891e450-b88b-4862-a138-b46b8b4d4b90/7280085c-436b-46f3-9854-b0ad70da2540_compressed_xj4.webp"
          alt=""
          className="w-full md:w-[110%] md:scale-110 h-full object-cover"
        />
      </div>

      {/* Dark overlay */}
      <div className="absolute inset-0 bg-espresso-900/70" />

      {/* Nav content */}
      <div className="absolute inset-0 flex items-center px-6">
        <div className="max-w-3xl mx-auto w-full flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <span
              className={`w-9 h-9 rounded-full flex items-center justify-center border transition-colors overflow-hidden ${
                scrolled
                  ? "bg-espresso-900 border-gold-400/60"
                  : "bg-cream-50/10 border-gold-300/50"
              }`}
            >
              <img
                src="https://storage.readdy-site.link/project_files/d891e450-b88b-4862-a138-b46b8b4d4b90/34dcd580-fc50-47e7-b8cf-0afc18add05d_compressed_logo.webp"
                alt="AOCigar logo"
                className="w-full h-full object-contain p-0.5"
              />
            </span>
            <div className="flex flex-col leading-tight">
              <span className="font-display text-lg text-cream-50">AOCigar</span>
              <span className="text-[10px] font-sc tracking-[0.25em] text-cream-100/70">百汇茄社</span>
            </div>
          </div>

          <nav className="hidden md:flex items-center gap-6 font-sc text-sm">
            <a
              href="#hero"
              className="text-cream-100/85 hover:text-gold-300 transition-colors cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
            >
              首页
            </a>
            <a
              href="#footer"
              className="text-cream-100/85 hover:text-gold-300 transition-colors cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                document.getElementById('footer')?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              关于我们
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
}